import { AnyAction, CombinedState, Reducer, combineReducers } from '@reduxjs/toolkit'
import assetPermissionsReducer, {
  AssetPermissionsSlice
} from '@dtx-company/inter-app/src/redux/slices/flowteams/assetPermissionsSlice'
import modalMembersTableReducer, {
  ModalMembersTableSliceState
} from '@dtx-company/inter-app/src/redux/slices/flowteams/modalMembersTableSlice'

export const flowteamsCombinedReducer: Reducer<
  CombinedState<{
    modalMembersTable: ModalMembersTableSliceState
    assetPermissions: AssetPermissionsSlice
  }>,
  AnyAction
> = combineReducers({
  modalMembersTable: modalMembersTableReducer,
  assetPermissions: assetPermissionsReducer
})
